import { PlatformCatalogSynchronisationStatus } from "@bvhi/backend-api";
import { Chip, ChipProps } from "@bvhi/ui-base";
import { CheckIcon, CloseIcon, RadioButtonUncheckedIcon } from "@bvhi/ui-icons";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  platformCatalogSynchronisationStatus: string;
  size?: "small" | "medium";
}

export function PlatformCatalogSynchronisationStatusChip({ platformCatalogSynchronisationStatus, size = "small" }: Props) {
  const { t } = useTranslation(["enums"]);

  let label = "";
  let icon: ReactNode = <CloseIcon />;
  let color: ChipProps["color"] = "default";

  switch (platformCatalogSynchronisationStatus) {
    case PlatformCatalogSynchronisationStatus.UNSYNCHRONISED:
      label = t("enums:enums.platform.catalog.synchronisation.status.unsynchronized");
      icon = <CloseIcon />;
      color = "warning";
      break;
    case PlatformCatalogSynchronisationStatus.SYNCHRONISED:
      label = t("enums:enums.platform.catalog.synchronisation.status.synchronized");
      icon = <CheckIcon />;
      color = "success";
      break;
    case PlatformCatalogSynchronisationStatus.MISMATCHED_RULES:
      label = t("enums:enums.platform.catalog.synchronisation.status.mismatched.rules");
      icon = <CloseIcon />;
      color = "error";
      break;
    case PlatformCatalogSynchronisationStatus.NOT_APPLICABLE:
      label = t("enums:enums.platform.catalog.synchronisation.status.not.applicable");
      icon = <RadioButtonUncheckedIcon />;
      color = "info";
      break;
  }

  return <Chip color={color} icon={icon} label={label} size={size} />;
}
